import { css } from '@emotion/react';
import { semanticTokens } from '@flysas-tech/commercial-ui';

const backdrop = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${semanticTokens.color.fill['transparent-pressed']};
  z-index: 11;
`;

export const PageBackdrop = ({ onClick }: { onClick?: VoidFunction }) => {
  return <div css={backdrop} onClick={onClick} />;
};
